'use client';
import React from 'react';
import { breakpointsCtx } from './utils/breakpoints-ctx';
import { useBreakpoints, BREAKPOINTS } from './utils/use-breakpoints';

const BreakpointsProvider = ({ children }) => {
  const breakpoints = useBreakpoints(BREAKPOINTS);
  return (
    <breakpointsCtx.Provider value={breakpoints}>
      {children}
    </breakpointsCtx.Provider>
  );
};

export { BreakpointsProvider };
